import React from 'react'
import ContextMenuItem from './ContextMenuItem'
import { AFFICHER_ADRESSE } from './contextmenu.constants'
import { useT } from '../../i18n/T'
import { useAction } from '../../utils/react-redux'
import { searchAddressFromPoint } from '../../../store/address/address.actions'

const ContextMenuItemShowAddress = () => {
  const label = useT('map.context-menu.show-address')
  const searchAddressFromPointAction = useAction(searchAddressFromPoint)

  return <ContextMenuItem tagAction={AFFICHER_ADRESSE} label={label} clickAction={searchAddressFromPointAction} />
}

export default ContextMenuItemShowAddress
